export type SearchIdentity = 'accommodation' | 'experiences' | 'cruises' | 'flights' | 'tours'

// Only public search identity and traveller details belong in a crawler's URL.
// Booking references, tracking and credentials deliberately do not participate.
const identityKeys: Record<SearchIdentity, Array<string>> = {
  accommodation: ['destinationId', 'destinationName', 'propertyId', 'propertyName', 'landmarkId', 'landmarkName', 'holidayTypes', 'adults', 'children'],
  experiences: ['destinationId', 'destinationName', 'categories', 'categoryCodes'],
  flights: ['originAirportCode', 'originAirportName', 'destinationAirportCode', 'destinationAirportName', 'departDate', 'returnDate', 'fareType', 'fareClass', 'adults', 'children', 'infants', 'childrenAge'],
  tours: ['destinationId', 'destinationName', 'tourGroupTypes', 'tourOperators', 'holidayTypes'],
  cruises: ['destinationIds', 'destinationNames', 'departureIds', 'departureNames', 'cruiseLines', 'cruiseShips'],
}

export function getSocialUrl(canonicalUrl: string, search: string, identity?: SearchIdentity): string {
  const baseUrl = canonicalUrl.split(/[?#]/)[0]
  const socialParams = new URLSearchParams()
  if (identity) {
    const params = new URLSearchParams(search)
    for (const key of identityKeys[identity]) {
      for (const value of params.getAll(key)) {
        if (value.trim()) socialParams.append(key, value.trim())
      }
    }
    if (identity === 'accommodation') {
      const hasDestination = ['destinationId', 'destinationName', 'holidayTypes'].some(key => socialParams.has(key))
      const hasPropertyOrLandmark = ['propertyId', 'propertyName', 'landmarkId', 'landmarkName'].some(key => socialParams.has(key))
      if (hasDestination && !hasPropertyOrLandmark) {
        // Destination/category routes require occupancy; preserve any supplied travellers.
        if (!socialParams.has('adults')) socialParams.set('adults', '2')
        if (!socialParams.has('children')) socialParams.set('children', 'none')
      }
    }
    if (identity === 'flights') {
      // Multi-city search uses indexed public route fields, never selected fares or booking IDs.
      const segmentKeys = [...params.keys()].filter(key => /^flights\[[0-5]\]\[(originAirportCode|originAirportName|destinationAirportCode|destinationAirportName|departDate)\]$/.test(key)).sort()
      for (const key of segmentKeys) socialParams.set(key, params.get(key)!)
    }
  }
  const query = socialParams.toString()
  return query ? `${baseUrl}?${query}` : baseUrl
}
